import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { OutOfOfficeModel } from '@smarttask-common/src/lib/models/Resource/OutOfOfficeModel';

export enum OutOfOfficeActionTypes {
    ADD_OOO = '[OutOfOffice] Create OutOfOffice',
    ADD_OOOS = '[OutOfOffice] Add OutOfOffices',
    UPSERT_OOO = '[OutOfOffice] Upsert OutOfOffice',
    UPSERT_OOOS = '[OutOfOffice] Upsert OutOfOffices',
    UPDATE_OOO = '[OutOfOffice] Update OutOfOffice',
    UPDATE_OOOS = '[OutOfOffice] Update OutOfOffices',
    DELETE_OOO = '[OutOfOffice] Delete OutOfOffice',
    DELETE_OOOS = '[OutOfOffice] Delete OutOfOffices',
    DELETE_ALL_OOOS = '[OutOfOffice] Delete All OutOfOffices',
    DELETE_ALL = '[OutOfOffice] Delete All',

    UPDATE_SELECTED_OOO = '[OutOfOffice] Update SelectedRole',
}

export class UpdateSelectedOutOfOffice implements Action {
    readonly type = OutOfOfficeActionTypes.UPDATE_SELECTED_OOO;
    constructor(public selected_ooo_uuid: string) {}
}

export class AddOne implements Action {
    readonly type = OutOfOfficeActionTypes.ADD_OOO;
    constructor(public ooo: OutOfOfficeModel) {}
}

export class AddMany implements Action {
    readonly type = OutOfOfficeActionTypes.ADD_OOOS;
    constructor(public ooos: Array<OutOfOfficeModel>) {}
}

export class UpsertOne implements Action {
    readonly type = OutOfOfficeActionTypes.UPSERT_OOO;

    constructor(public ooo: OutOfOfficeModel) {}
}

export class UpsertMany implements Action {
    readonly type = OutOfOfficeActionTypes.UPSERT_OOOS;
    constructor(public ooos: Array<OutOfOfficeModel>) {}
}

export class UpdateOne implements Action {
    readonly type = OutOfOfficeActionTypes.UPDATE_OOO;
    constructor(public ooo: Update<OutOfOfficeModel>) {}
}

export class UpdateMany implements Action {
    readonly type = OutOfOfficeActionTypes.UPDATE_OOOS;
    constructor(public ooos: Array<Update<OutOfOfficeModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = OutOfOfficeActionTypes.DELETE_OOO;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = OutOfOfficeActionTypes.DELETE_OOOS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = OutOfOfficeActionTypes.DELETE_ALL_OOOS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = OutOfOfficeActionTypes.DELETE_ALL;
    constructor() {}
}

export type OutOfOfficeActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedOutOfOffice;
